import { useMemo } from 'react';

export const useColumnGroupingModel = (weeklyPayrollReportData) => {
  return useMemo(() => {
    if (!weeklyPayrollReportData || !weeklyPayrollReportData.headers) {
      return [];
    }

    return [
      {
        groupId: 'timeInfo',
        headerName: 'Full time',
        description: 'Basic employee information',
        children: [{ field: 'fullName' }],
      },

      {
        groupId: 'wkly',
        headerName: 'wkly',
        description: 'Regular working hours',
        children: [{ field: 'regularHours' }],
      },

      {
        groupId: 'deduct',
        headerName: 'Deduct',
        description: 'Deducted hours (sick leave and vacation)',
        children: [{ field: 'sickHours' }, { field: 'vacationHours' }],
      },

      {
        groupId: 'totalHours',
        headerName: 'Reg.',
        description: 'Total Hours',
        children: [{ field: 'totalHours' }],
      },

      {
        groupId: 'regularPay',
        headerName: 'Regular',
        description: 'Regular hourly rate and weekly pay',
        children: [{ field: 'hourlyRate' }, { field: 'weeklyPay' }],
      },

      {
        groupId: 'actOff',
        headerName: 'Act/Off',
        description: 'Additional hours and rate information',
        children: [{ field: 'additionalHours' }, { field: 'rate2' }],
      },

      {
        groupId: 'dispatchPayHours',
        headerName: 'Dispatch Pay Hours',
        description: 'Dispatch rates and amounts',
        children: [
          { field: 'rate23' },
          { field: 'amount1' },
          { field: 'rate34_50' },
          { field: 'amount2' },
        ],
      },

      {
        groupId: 'overtimePay',
        headerName: 'Overtime Pay',
        description: 'Rate and amount information',
        children: [
          { field: 'hourlyRate2' },
          { field: 'overtimeHours1' },
          { field: 'overtimeRate1' },
          { field: 'overtimeHours2' },
          { field: 'overtimeRate2' },
          { field: 'overtimeHours3' },
          { field: 'overtimeRate3' },
        ],
      },

      {
        groupId: 'paidHoliday',
        headerName: 'Paid Holiday',
        description: 'Paid Holiday',
        children: [{ field: 'hours10' }, { field: 'amount3' }],
      },

      {
        groupId: 'fire',
        headerName: 'Fire',
        description: 'Fire',
        children: [{ field: 'detail' }],
      },

      {
        groupId: 'total',
        headerName: 'Total',
        description: 'Total Pay',
        children: [{ field: 'totalPay' }],
      },
    ];
  }, [weeklyPayrollReportData]);
};

export default useColumnGroupingModel;
